import { PlusOutlined } from '@ant-design/icons'
import { Button, Flex } from 'antd'
import React from 'react'
import {
  ConfigurationType,
  FormConfigurationType,
} from '~/features/formConfiguration/common'
import { Toolbox } from '~/plugins/toolbox/shared'
import { usePreparation } from '../../hooks/usePreparation'
import { Step } from '../Step'
import { StepDefault } from '../StepDefault'

type Props = {
  formConfiguration: FormConfigurationType
  onChange: (values: FormConfigurationType) => void
}

export const Builder: React.FC<Props> = ({ formConfiguration, onChange }) => {
  const configuration = usePreparation({ formConfiguration })

  const handleChange = (configurationUpdated: ConfigurationType) => {
    const configurationCleaned =
      Toolbox.Utility.trimNullValues(configurationUpdated)

    onChange({
      ...formConfiguration,
      configuration: configurationCleaned as any,
    })
  }

  const handleChangeDefault = (
    valuesUpdated: Partial<FormConfigurationType>,
  ) => {
    onChange({
      ...formConfiguration,
      ...valuesUpdated,
    })
  }

  const handleAddStep = () => {
    onChange({
      ...formConfiguration,
      configuration: {
        ...(configuration as any),
        steps: [
          ...configuration.steps,
          {
            key: `step${configuration.steps.length}`,
          },
        ],
      },
    })
  }

  return (
    <>
      <Flex vertical className="w-full" gap={40}>
        <StepDefault
          formConfiguration={formConfiguration}
          onChange={handleChangeDefault}
        />

        {configuration.steps.map((step, index) => (
          <Step
            key={index}
            index={index}
            configuration={configuration}
            step={step}
            onChange={handleChange}
            onChangeInstant={handleChange}
          />
        ))}

        <Flex>
          <Button icon={<PlusOutlined />} onClick={handleAddStep}>
            Add step
          </Button>
        </Flex>
      </Flex>
    </>
  )
}
